<div class="input">
  <mat-form-field [class]="!isMaterialLabel ? 'custom-label' : ''">
    <mat-label *ngIf="isMaterialLabel && label">{{ label }}</mat-label>
    <input
      (change)="valueChanged()"
      [autocomplete]="autocomplete"
      [formControl]="control"
      [id]="inputId"
      [placeholder]="placeholder"
      [readonly]="isDisabled"
      [type]="type"
      [inputMask]="mask"
      matInput
    />
    <button
      (click)="toggleInputType($event)"
      *ngIf="initialType === 'password' && !hideReveal"
      aria-label="show"
      mat-icon-button
      matIconSuffix
    >
      <mat-icon *ngIf="initialType === 'password' && type === 'password'">
        visibility
      </mat-icon>
      <mat-icon *ngIf="initialType === 'password' && type === 'text'">
        visibility_off
      </mat-icon>
    </button>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="control.hasError('maxlength')">
      Value should not contain more than
      {{ control.errors?.['maxlength']?.['requiredLength'] }} characters
    </mat-error>
    <mat-error *ngIf="control.hasError('email')">
      Please provide valid email address
    </mat-error>
    <mat-error *ngIf="control.hasError('invalidPassword')">
      Your password does not meet the correct criteria.
    </mat-error>
    <mat-error *ngIf="control.hasError('emptyString')">
      Please enter a valid {{ label }}.
    </mat-error>
    <mat-error *ngIf="control.hasError('invalidConfirmation')">
      {{ control.getError('invalidConfirmation') }}
    </mat-error>
    <mat-error *ngIf="control.hasError('pattern')">
      Value contain invalid characters.
    </mat-error>
    <mat-error *ngIf="control.hasError('invalidFormat')">
      {{
        control.errors?.['invalidFormat'].message || 'Value is in wrong format'
      }}
    </mat-error>
  </mat-form-field>
</div>
